export const MARKET_DENMARK = 'dk';
export const MARKET_GERMANY = 'de';
export const MARKET_SWEDEN = 'se';
export const MARKET_NORWAY = 'no';

export const normalizeMarket = (value) => {
  const raw = String(value || '').trim().toLowerCase();
  if (raw.startsWith('de') || raw === 'germany' || raw === 'deutschland') {
    return MARKET_GERMANY;
  }
  if (raw.startsWith('sv') || raw === 'sweden' || raw === 'sverige') {
    return MARKET_SWEDEN;
  }
  if (raw.startsWith('nb') || raw.startsWith('no') || raw === 'norway' || raw === 'norge') {
    return MARKET_NORWAY;
  }
  return MARKET_DENMARK;
};

export const detectMarket = () => {
  if (typeof window === 'undefined') {
    return MARKET_DENMARK;
  }

  const cachedLanguage = window.localStorage.getItem('i18nextLng');
  if (cachedLanguage) {
    return normalizeMarket(cachedLanguage);
  }

  const browserLanguages = [navigator.language, ...(navigator.languages || [])]
    .filter(Boolean)
    .map((value) => value.toLowerCase());

  if (browserLanguages.some((value) => value.startsWith('de'))) {
    return MARKET_GERMANY;
  }
  if (browserLanguages.some((value) => value.startsWith('sv') || /(^|-)se$/.test(value))) {
    return MARKET_SWEDEN;
  }
  if (browserLanguages.some((value) => value.startsWith('nb') || value.startsWith('no') || /(^|-)no$/.test(value))) {
    return MARKET_NORWAY;
  }
  if (browserLanguages.some((value) => value.startsWith('da') || /(^|-)dk$/.test(value))) {
    return MARKET_DENMARK;
  }

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone?.toLowerCase() || '';
  if (timezone === 'europe/berlin') {
    return MARKET_GERMANY;
  }
  if (timezone === 'europe/stockholm') {
    return MARKET_SWEDEN;
  }
  if (timezone === 'europe/oslo') {
    return MARKET_NORWAY;
  }
  if (timezone === 'europe/copenhagen') {
    return MARKET_DENMARK;
  }

  return MARKET_DENMARK;
};

export const getCurrencyForMarket = (market) => (
  {
    [MARKET_GERMANY]: 'EUR',
    [MARKET_SWEDEN]: 'SEK',
    [MARKET_NORWAY]: 'NOK',
  }[normalizeMarket(market)] || 'DKK'
);

export const getLocaleForMarket = (market) => (
  {
    [MARKET_GERMANY]: 'de-DE',
    [MARKET_SWEDEN]: 'sv-SE',
    [MARKET_NORWAY]: 'nb-NO',
  }[normalizeMarket(market)] || 'da-DK'
);

export const formatMarketCurrency = (amount, market) => {
  const numericAmount = Number(amount || 0);
  const currency = getCurrencyForMarket(market);
  const locale = getLocaleForMarket(market);

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  }).format(numericAmount);
};